import { useState, useEffect } from 'react';
import { getTabIndicesWithErrors } from '@/utils/errors.js';

export function useFormTab({ form, fieldsByTab, onSubmit }) {
  const [activeTab, setActiveTab] = useState(0);
  const [switchTab, setSwitchTab] = useState(false);
  const tabIndicesWithErrors = getTabIndicesWithErrors(form.formState.errors, fieldsByTab);

  useEffect(() => {
    if (switchTab && tabIndicesWithErrors.length > 0 && !tabIndicesWithErrors.includes(activeTab)) {      
      setActiveTab(tabIndicesWithErrors[0]);      
    }
    if (switchTab) {      
      setSwitchTab(false);
    }
  }, [tabIndicesWithErrors, activeTab, switchTab]);

  function onFormSubmit(e) {                
    const result = form.handleSubmit(onSubmit)(e);        
    setSwitchTab(true);
    return result;
  }

  return { activeTab, setActiveTab, tabIndicesWithErrors, onFormSubmit };
}
